import React from 'react';
import { IAPIClient } from '@askporter/api-client';
import { Media, useDragAndDropUpload } from '@askporter/utils';
import { FileUploader } from '../FileUploader';
import type { FileUploaderProps } from '../types';

export type FileUploaderComposerProps = Omit<
  FileUploaderProps,
  'onInvalidFilesDrop' | 'onValidFilesDrop' | 'onDelete' | 'uploaderDisabled' | 'deletionEnabled'
> & {
  idPrefix: string;
  t: (key: string) => string;
  API: () => IAPIClient;
  value: Media[];
  onChange: (files: Media[]) => void;
  onError: (error: string) => void;
  disabled?: boolean;
};

export const FileUploaderComposer: React.FC<FileUploaderComposerProps> = ({
  t,
  idPrefix,
  API,
  value,
  onChange,
  maxFiles = 1,
  deleteButtonVisible,
  accept,
  helperText,
  onError,
  containerProps,
  disabled,
  hideFileList,
  hideStateLabel,
  showImageThumbnail,
  required,
  requiredFileError,
}) => {
  const { isUploading, onValidFilesDrop, onInvalidFilesDrop, onDelete, disableUploader, files } = useDragAndDropUpload({
    files: value,
    maxFiles,
    API,
    onError,
    t,
    onChange: (files) => {
      onChange(files);
    },
  });

  return (
    <FileUploader
      t={t}
      idPrefix={idPrefix}
      value={files}
      maxFiles={maxFiles}
      accept={accept}
      uploaderDisabled={disableUploader || disabled}
      onValidFilesDrop={onValidFilesDrop}
      onInvalidFilesDrop={onInvalidFilesDrop}
      deleteButtonVisible={deleteButtonVisible}
      deletionEnabled={!isUploading && !disabled}
      onDelete={onDelete}
      helperText={helperText}
      containerProps={containerProps}
      hideFileList={hideFileList}
      hideStateLabel={hideStateLabel}
      showImageThumbnail={showImageThumbnail}
      required={required}
      requiredFileError={requiredFileError}
    />
  );
};
